import { render, staticRenderFns } from "./SelectPackage.vue?vue&type=template&id=0cbd4d9c&scoped=true"
import script from "./SelectPackage.vue?vue&type=script&lang=js"
export * from "./SelectPackage.vue?vue&type=script&lang=js"
import style0 from "./SelectPackage.vue?vue&type=style&index=0&id=0cbd4d9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd4d9c",
  null
  
)

export default component.exports